module.exports = __webpack_public_path__ + "img/stock0.1f38aaec.png";